<template>
    <div>
        <div class="font-Montserrat font-bold text-5xl text-center mb-[40px] ">{{ $t('Anime-Results') }}</div>
        <div class="relative flex flex-col items-center justify-center">
            <button
                class="hover:-translate-y-2 duration-200 px-10 py-3 bg-gradient-3 hover:bg-linear-gradient flex items-center text-white rounded-full ">
                <EnhanceUpload :fileType="fileType" class="absolute left-0 h-16 w-[257px] opacity-0"
                    :acceptCount="acceptCount">
                </EnhanceUpload>
                <NuxtImg src="/assets/images/functype/allTools/newImgs/upload.webp" alt="arrow" width="24" height="24"
                    loading="lazy" />
                <div class="flex flex-col ml-6 text-left">
                    <div class="Roboto-Bold-20">
                        {{ $t('upload-image') }}
                    </div>
                    <div class="Roboto-12 text-[#FFFFFF66] mt-1">
                        {{ $t('upload-action') }}
                    </div>
                </div>
            </button>
            <div style="line-height: 20px;" class="mt-8 text-text-gray Roboto-14">{{ $t('tools-upload-size') }}</div>
        </div>
        <div class="mt-16">
            <div class="flex items-center justify-center rounded-xl overflow-hidden">

                <div class="border-r-4 border-black relative">
                    <div
                        class="absolute left-5 top-5 text-white h-9 bg-[#57575799] rounded-3xl px-4 flex items-center border border-[#ffffff66]">
                        {{ $t("before") }}
                    </div>
                    <NuxtImg width="600" height="400" :src="imgList[indexImg].imgBefore"></NuxtImg>
                </div>
                <div key="after" class="relative">
                    <div
                        class="absolute right-5 top-5 text-white h-9 bg-mainColor-deep rounded-3xl px-4 flex items-center border border-[#ffffff66]">
                        {{ $t("after") }}
                    </div>
                    <NuxtImg width="600" height="400" :src="imgList[indexImg].imgAfter"></NuxtImg>
                </div>
            </div>
            <div class="flex items-center justify-center cursor-pointer mt-8">
                <div @click="onClick(items)" v-for="(items, index) in imgList" :key="items.key" :value="items.key"
                    class="p-2 mx-4 rounded-xl " :class="{ 'bg-white shadow-lg': index == indexImg }">
                    <NuxtImg class="rounded-lg" width="144" height="96" :src="items.imgAfter" @mouseover="stopTimer()"
                        @mouseleave="startTimer()">
                    </NuxtImg>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
const props = defineProps({
    funcType: {
        type: String,
        default: "enhance_pro",
    },
    acceptCount: {
        type: Number,
        default: 1,
    }
});
const { t } = useI18n();
const indexImg = ref(0)
const imgList = ref([
    { key: 0, imgBefore: '/assets/images/functype/allTools/newImgs/anime_before-4.webp', imgAfter: '/assets/images/functype/allTools/newImgs/anime_after-4.webp' },
    { key: 1, imgBefore: '/assets/images/functype/allTools/newImgs/anime_before-1.webp', imgAfter: '/assets/images/functype/allTools/newImgs/anime_after-1.webp' },
    { key: 2, imgBefore: '/assets/images/functype/allTools/newImgs/anime_before-2.webp', imgAfter: '/assets/images/functype/allTools/newImgs/anime_after-2.webp' },
    { key: 3, imgBefore: '/assets/images/functype/allTools/newImgs/anime_before-3.webp', imgAfter: '/assets/images/functype/allTools/newImgs/anime_after-3.webp' },
    { key: 4, imgBefore: '/assets/images/functype/allTools/newImgs/anime_before-5.webp', imgAfter: '/assets/images/functype/allTools/newImgs/anime_after-5.webp' }
])
function onClick(params) {
    indexImg.value = params.key
}
const fileType = ref(
    props.funcType.toLocaleLowerCase().includes("video") ? FileType.video : FileType.image
);
let timer = null

// 启动定时器
const startTimer = () => {
    timer = setInterval(() => {
        indexImg.value = (indexImg.value + 1) % imgList.value.length
    }, 3000) // 3秒切换一次
}

// 停止定时器
const stopTimer = () => {
    if (timer) {
        clearInterval(timer)
        timer = null
    }
}

// 组件挂载时启动定时器
onMounted(() => {
    startTimer()
})

// 组件卸载时清除定时器（防止内存泄漏）
onUnmounted(() => {
    stopTimer()
})
</script>
<style scoped></style>